(function () {
  'use strict';

  angular
    .module('importacaoMotorista')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.importacaoMotorista', {
        url: '/importacao-motorista',
        views: {
          'content@': {
            templateUrl: 'importacao-motorista/importacao-motorista.tpl.html',
            controller: 'ImportacaoMotoristaCtrl',
            controllerAs: 'importacaoMotorista'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.importacaoMotorista.titulo',
          role: 'UO_EDITAR'
        }
      });
  }
}());
